import { useState, useEffect, useRef } from "react";
import Countdown from "./Countdown";

const ALBUMS = [
  {
    id: 2,
    title: "Dugnas",
    year: "2026",
    type: "EP",
    duration: "17min 26s",
    image: "https://i.scdn.co/image/ab67616d00001e02b02576da09c61a106a30fc68",
    tracks: [
      { id: 20, name: "Žaizdos negyja//Gedulas ryja", secs: 322 },
      { id: 21, name: "Neišeik!", secs: 172 },
      { id: 22, name: "Meilės trūksta", secs: 145 },
      { id: 23, name: "Miegu su kita", secs: 223 },
      { id: 24, name: "Suoliukas", secs: 182 },
    ],
    word: "dainos",
  },
  {
    id: 1,
    title: "Pavasarį pražysim",
    year: "2025",
    type: "Album",
    duration: "30min 1s",
    image: "https://i.scdn.co/image/ab67616d0000b273ec330d62a3e41b201277817d",
    tracks: [
      { id: 10, name: "Pavasarį pražysim", secs: 254 },
      { id: 11, name: "Vis tiek", secs: 273 },
      { id: 12, name: "Žmonės be sielų", secs: 212 },
      { id: 13, name: "Vyno", secs: 178 },
      { id: 14, name: "Paleisk", secs: 215 },
      { id: 15, name: "Skruostai raudonuoja", secs: 194 },
      { id: 16, name: "Amžinai", secs: 209 },
      { id: 17, name: "Ramunėlių žiedais", secs: 262 },
    ],
    word: "dainos",
  },
  {
    id: 0,
    title: "Gilyn į jūrą",
    year: "2025",
    type: "Single",
    duration: "2min 57s",
    image: "https://i.scdn.co/image/ab67616d00001e021b5713dcc712df43c6ce9dc2",
    tracks: [{ id: 0, name: "Gilyn į jūrą", secs: 177 }],
    word: "daina",
  },
];

const navMap = {
  shows: "koncertai",
  music: "muzika",
};

const SHOWS = [
  {
    date: new Date("2026-06-22"),
    venue: "Kultūros centras",
    city: "Ukmergė",
  },
];

const MEMBERS = [
  {
    name: "Rusnė",
    role: "Vokalas/Žodžiai",
    em: "🎤",
    bg: "linear-gradient(135deg,#ffe0e6,#ffb3c1)",
  },
  {
    name: "Saulė",
    role: "Gitara",
    em: "🎸",
    bg: "linear-gradient(135deg,#ffd6dd,#ffaab8)",
  },
  {
    name: "Evelina",
    role: "Bosinė",
    em: "🎸",
    bg: "linear-gradient(135deg,#ffd6dd,#ffaab8)",
  },
  {
    name: "Ugnė",
    role: "Bugnai",
    em: "🥁",
    bg: "linear-gradient(135deg,#ffe8ec,#ffccd3)",
  },
  {
    name: "Martyna",
    role: "Klavišai",
    em: "🎹",
    bg: "linear-gradient(135deg,#ffecef,#ffd6dd)",
  },
];

function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
}

function formatTimeWords(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes}min ${remainingSeconds.toString().padStart(2, "0")}s`;
}

function formatDate(date) {
  const parts = new Intl.DateTimeFormat("lt-LT", {
    year: "numeric",
    month: "long",
  }).formatToParts(date);

  const month = parts.find((p) => p.type === "month").value;
  const year = parts.find((p) => p.type === "year").value;

  const result = `${month} ${year} m.`;
  return result;
}

function Confetti() {
  const pieces = useRef([]);
  useEffect(() => {
    const colors = [
      "#e8192c",
      "#ffd6dd",
      "#ffaab8",
      "#ff6b7a",
      "#ffccd3",
      "#e8192c",
      "#ff2d42",
    ];
    pieces.current = Array.from({ length: 24 }, (_, i) => ({
      left: Math.random() * 100,
      size: 5 + Math.random() * 9,
      dur: 11 + Math.random() * 13,
      delay: Math.random() * 18,
      color: colors[i % colors.length],
      circle: Math.random() > 0.4,
    }));
  }, []);
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      {pieces.current.map((d, i) => (
        <div
          key={i}
          className="confetti-piece"
          style={{
            left: `${d.left}vw`,
            top: "-20px",
            width: `${d.size}px`,
            height: `${d.size}px`,
            background: d.color,
            borderRadius: d.circle ? "50%" : "3px",
            animation: `fall ${d.dur}s ${d.delay}s linear infinite`,
          }}
        />
      ))}
    </div>
  );
}

function Nav({ scrollTo }) {
  return (
    <nav className="nav">
      <span className="nav-logo">
        <span className="spin-flower">✿</span> sniukas
      </span>
      <ul className="nav-links">
        {["music", "shows"].map((s) => (
          <li key={s}>
            <button onClick={() => scrollTo(s)}>{navMap[s]}</button>
          </li>
        ))}
        <li>
          <button className="nav-cta" onClick={() => scrollTo("connect")}>
            sekite mus čia ♡
          </button>
        </li>
      </ul>
    </nav>
  );
}

function Hero({ scrollTo }) {
  return (
    <section className="hero" id="hero">
      <div className="hero-blob1" />
      <div className="hero-blob2" />
      <Confetti />
      <div className="hero-eyebrow">
        <div className="badge-dot" />
        naujas ep jau live ✿
      </div>
      <h1 className="hero-title">
        <span className="ht1">SNIUKAS</span>
        <span className="ht2">SNIUKAS</span>
      </h1>
      <p className="hero-hand">indie · indie · indie ♡</p>
      <p className="hero-sub">
        aprašymas apie mus, kažkoks fun lalala
        <br />
        manau bus liux
      </p>
      <div className="hero-ctas">
        <button className="btn-red" onClick={() => scrollTo("music")}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <polygon points="3,1 11,6 3,11" />
          </svg>
          paklausom
        </button>
        <button className="btn-ghost" onClick={() => scrollTo("shows")}>
          susimatom?
        </button>
      </div>
      <div className="hero-members">
        {MEMBERS.map((m) => (
          <div key={m.name} className="mbub">
            <div className="mbub-av" style={{ background: m.bg }}>
              {m.em}
            </div>
            <div>
              <div className="mbub-name">{m.name.split(" ")[0]}</div>
              <div className="mbub-role">{m.role}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function Music({
  activeTrack,
  setActiveTrack,
  setActiveAlbum,
  isPlaying,
  setIsPlaying,
}) {
  const [albumIndex, setAlbumIndex] = useState(0);

  const album = ALBUMS[albumIndex];

  const switchAlbum = (i) => {
    if (i === albumIndex) return;
    setAlbumIndex(i);
    setIsPlaying(false);
  };

  return (
    <section className="section music-sec" id="music">
      <div className="eyebrow">🎵 muzika</div>
      <h2 className="sec-title">
        ką jau esame <em style={{ color: "var(--red)" }}> iškepusios</em>{" "}
      </h2>

      <div className="album-carousel">
        {/* Tab switcher */}
        <div className="album-tabs">
          {ALBUMS.map((a, i) => (
            <button
              key={a.id}
              className={`album-tab${i === albumIndex ? " active" : ""}`}
              onClick={() => switchAlbum(i)}
            >
              <span className="album-tab-emoji">{a.emoji}</span>
              <span className="album-tab-name">{a.title}</span>
              <span className="album-tab-year">{a.year}</span>
            </button>
          ))}
        </div>

        <div className="ep-card">
          <div className="ep-art">
            <img src={album.image}></img>
          </div>
          <div className="ep-card-info">
            <div className="ep-title">{album.title}</div>
            <div className="ep-meta">
              {album.type} · {album.tracks.length} {album.word} ·{" "}
              {album.duration} · {album.year}
            </div>
          </div>
        </div>
      </div>

      {/* Dot indicators */}
      <div className="album-dots">
        {ALBUMS.map((_, i) => (
          <button
            key={i}
            className={`album-dot${i === albumIndex ? " active" : ""}`}
            onClick={() => {
              setAlbumIndex(i);
              setIsPlaying(false);
            }}
            aria-label={`Album ${i + 1}`}
          />
        ))}
      </div>

      {/* Track list */}
      <div className="track-list">
        {album.tracks.map((t, index) => {
          const on = activeTrack === t.id;
          return (
            <div
              key={t.id}
              className={`track-row${on ? " active" : ""}`}
              onClick={() => {
                if (on) {
                  setIsPlaying((p) => !p);
                } else {
                  setActiveTrack(t.id);
                  setActiveAlbum(album);
                  setIsPlaying(true);
                }
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 24,
                  height: 24,
                }}
              >
                <span className="track-n">{index + 1}</span>
                <div className="wavebars">
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </div>
              <div>
                <div className="track-name">{t.name}</div>
                <div className="track-by">Sniukas</div>
              </div>
              <span className="track-dur">{formatTime(t.secs)}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}

function Shows({ scrollTo }) {
  return (
    <section className="section shows-sec" id="shows">
      <div className="eyebrow">🎤 koncertai</div>
      <h2 className="sec-title">
        kada
        <br />
        <em style={{ color: "var(--red)" }}> susimatom?</em>
      </h2>
      {SHOWS.filter((x) => x.date > Date.now()).length > 0 ? (
        SHOWS.filter((x) => x.date > Date.now()).map((s, i) => (
          <div key={i} className="show-row">
            <div>
              <div className="show-dd">{s.date.getDay()}</div>
              <div className="show-mo">{formatDate(s.date)}</div>
            </div>
            <div>
              <div className="show-venue">{s.venue}</div>
              <div className="show-city">{s.city}</div>
              <Countdown targetDate={s.date.toString()} />
            </div>
            <button
              className={`show-btn avail`}
              onClick={() => {
                window.open("https://www.facebook.com");
              }}
            >
              daugiau čia →
            </button>
          </div>
        ))
      ) : (
        <div>
          {" "}
          <p className="hero-sub-copy">
            kol kas neturime nieko konkretaus, tačiau
          </p>{" "}
          <button className="nav-cta-copy" onClick={() => scrollTo("connect")}>
            sekite mus čia ♡
          </button>
        </div>
      )}
    </section>
  );
}

function Connect() {
  return (
    <section className="section connect-sec" id="connect">
      <div className="eyebrow" style={{ justifyContent: "center" }}>
        💌 sekite mus
      </div>
      <h2 className="connect-title">
        <span className="ct1">palaikome</span>
        <span className="ct2">ryšį</span>
      </h2>
      <p className="connect-sub"></p>
      <div className="socials-row">
        {[
          {
            i: (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#1DB954" />
                <path
                  d="M17.3 16.8C17 17.2 16.5 17.3 16.1 17C13.5 15.4 10.2 15 6.3 15.9C5.8 16 5.4 15.7 5.3 15.3C5.2 14.8 5.5 14.4 5.9 14.3C10.3 13.3 14.1 13.8 17 15.7C17.4 15.9 17.5 16.4 17.3 16.8Z"
                  fill="black"
                />
                <path
                  d="M18.7 13.7C18.3 14.2 17.7 14.4 17.2 14.1C14.2 12.2 9.6 11.7 6 12.8C5.4 13 4.8 12.6 4.6 12C4.4 11.4 4.8 10.8 5.4 10.6C9.5 9.4 14.7 9.9 18.4 12.2C18.9 12.5 19.1 13.1 18.7 13.7Z"
                  fill="black"
                />
                <path
                  d="M18.9 10.3C15.4 8.2 9.7 8 6.3 9C5.6 9.2 4.9 8.8 4.7 8.1C4.5 7.4 4.9 6.7 5.6 6.5C9.5 5.3 15.9 5.6 20.2 8.1C20.8 8.4 21 9.2 20.6 9.8C20.2 10.4 19.5 10.6 18.9 10.3Z"
                  fill="black"
                />
              </svg>
            ),
            l: "Spotify",
            handler: () => {
              window.open(
                "https://open.spotify.com/artist/2eivzFnQOXEXDNQy2qTrK1",
              );
            },
          },
          {
            i: (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient
                    id="instagramGradient"
                    x1="4"
                    y1="20"
                    x2="20"
                    y2="4"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FEDA75" />
                    <stop offset="0.3" stopColor="#FA7E1E" />
                    <stop offset="0.6" stopColor="#D62976" />
                    <stop offset="0.8" stopColor="#962FBF" />
                    <stop offset="1" stopColor="#4F5BD5" />
                  </linearGradient>
                </defs>
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="5"
                  fill="url(#instagramGradient)"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="4.25"
                  stroke="white"
                  strokeWidth="1.8"
                />
                <circle cx="17.2" cy="6.8" r="1.2" fill="white" />
              </svg>
            ),
            l: "Instagram",
            handler: () => {
              window.open("https://www.instagram.com/sniukas_/");
            },
          },
          {
            i: (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 2C18 4.1 19.6 5.7 21.7 6.2V9.1C20.2 9.1 18.8 8.7 17.5 7.9V14.2C17.5 18 14.4 21 10.6 21C6.9 21 3.8 18 3.8 14.2C3.8 10.5 6.9 7.4 10.6 7.4C11.1 7.4 11.5 7.5 12 7.6V10.7C11.6 10.6 11.1 10.5 10.6 10.5C8.6 10.5 6.9 12.2 6.9 14.2C6.9 16.3 8.6 18 10.6 18C12.7 18 14.4 16.3 14.4 14.2V2H17.5Z"
                  fill="#000000"
                />
              </svg>
            ),
            l: "TikTok",
          },
          {
            i: (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.5 6.2C23.2 5 22.3 4.1 21.1 3.8C18.9 3.2 12 3.2 12 3.2C12 3.2 5.1 3.2 2.9 3.8C1.7 4.1 0.8 5 0.5 6.2C0 8.4 0 12 0 12C0 12 0 15.6 0.5 17.8C0.8 19 1.7 19.9 2.9 20.2C5.1 20.8 12 20.8 12 20.8C12 20.8 18.9 20.8 21.1 20.2C22.3 19.9 23.2 19 23.5 17.8C24 15.6 24 12 24 12C24 12 24 8.4 23.5 6.2Z"
                  fill="#FF0000"
                />
                <path d="M9.75 15.5V8.5L15.75 12L9.75 15.5Z" fill="white" />
              </svg>
            ),
            l: "YouTube",
            handler: () => {
              window.open(
                "https://www.youtube.com/channel/UCdzzQQm92-uroNK0ePMS90A",
              );
            },
          },
        ].map((s) => (
          <button key={s.l} className="soc-pill" onClick={s.handler}>
            {s.i} {s.l}
          </button>
        ))}
      </div>
    </section>
  );
}

function Player({
  activeTrack,
  activeAlbum,
  isPlaying,
  setIsPlaying,
  setActiveTrack,
}) {
  const [elapsed, setElapsed] = useState(0);
  const rafRef = useRef(null);
  const lastRef = useRef(null);
  const track = ALBUMS.flatMap((x) => x.tracks).find(
    (track) => track.id === activeTrack,
  );

  const audioRef = useRef(new Audio());

  useEffect(() => {
    audioRef.current.src = "/muzika/" + activeTrack + ".webm";
    if (isPlaying) audioRef.current.play();
  }, [activeTrack]);

  useEffect(() => {
    isPlaying ? audioRef.current.play() : audioRef.current.pause();
  }, [isPlaying]);

  useEffect(() => {
    if (isPlaying) {
      lastRef.current = performance.now();
      const tick = (now) => {
        const dt = (now - lastRef.current) / 1000;
        lastRef.current = now;
        setElapsed((e) => {
          const n = e + dt;
          if (n >= track.secs) {
            setIsPlaying(false);
            return 0;
          }
          return n;
        });
        rafRef.current = requestAnimationFrame(tick);
      };
      rafRef.current = requestAnimationFrame(tick);
    } else {
      cancelAnimationFrame(rafRef.current);
    }
    return () => cancelAnimationFrame(rafRef.current);
  }, [isPlaying, track.secs]);

  useEffect(() => setElapsed(0), [activeTrack]);
  const pct = (elapsed / track.secs) * 100;
  const fmt = (s) =>
    `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;

  return (
    <div className="player up">
      <div className={`player-art${isPlaying ? " spin" : ""}`}>
        <img src={activeAlbum.image}></img>
      </div>
      <div className="player-info">
        <div className="player-tname">{track.name}</div>
        <div className="player-tartist">{activeAlbum.title}</div>
      </div>
      <div className="player-controls">
        <button
          className="pbt"
          onClick={() => {
            let currentTrackInAlbum = activeAlbum.tracks.find(
              (x) => x.id == activeTrack,
            );
            let index = activeAlbum.tracks.indexOf(currentTrackInAlbum);
            let nextIndex = index - 1;
            if (nextIndex < 0) {
              nextIndex = activeAlbum.tracks.length - 1;
            }
            let nextSong = activeAlbum.tracks[nextIndex];
            setActiveTrack(nextSong.id);
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 6h2v12H6zm3.5 6 8.5 6V6z" />
          </svg>
        </button>
        <button
          className="pbt pbt-play"
          onClick={() => setIsPlaying((p) => !p)}
        >
          {isPlaying ? (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="4" width="4" height="16" />
              <rect x="14" y="4" width="4" height="16" />
            </svg>
          ) : (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5,3 19,12 5,21" />
            </svg>
          )}
        </button>
        <button
          className="pbt"
          onClick={() => {
            let currentTrackInAlbum = activeAlbum.tracks.find(
              (x) => x.id == activeTrack,
            );
            let index = activeAlbum.tracks.indexOf(currentTrackInAlbum);
            let nextIndex = index + 1;
            if (nextIndex >= activeAlbum.tracks.length) {
              nextIndex = 0;
            }
            let nextSong = activeAlbum.tracks[nextIndex];
            setActiveTrack(nextSong.id);
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 18l8.5-6L6 6v12zm10-12v12h2V6h-2z" />
          </svg>
        </button>
      </div>
      <div className="player-prog">
        <div className="prog-track">
          <div className="prog-fill" style={{ width: `${pct}%` }} />
        </div>
        <div className="prog-times">
          <span>{fmt(elapsed)}</span>
          <span>{formatTime(track.secs)}</span>
        </div>
      </div>
    </div>
  );
}

export default function Main() {
  const [activeTrack, setActiveTrack] = useState(20);
  const [activeAlbum, setActiveAlbum] = useState(ALBUMS[0]);
  const [isPlaying, setIsPlaying] = useState(false);

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <>
      <Nav scrollTo={scrollTo} />
      <Hero scrollTo={scrollTo} />
      <Music
        activeTrack={activeTrack}
        setActiveTrack={setActiveTrack}
        setActiveAlbum={setActiveAlbum}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
      />
      <Shows scrollTo={scrollTo} />
      <Connect />
      <Player
        activeTrack={activeTrack}
        activeAlbum={activeAlbum}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        setActiveTrack={setActiveTrack}
      />
    </>
  );
}
